// extracted by mini-css-extract-plugin
module.exports = {"body":"FolderPickerDialog_body__E5XC1","error":"FolderPickerDialog_error__FJpWM"};